/**
 * Whether this browser can draw the report's 3D figure (three.js needs WebGL 2).
 * Kept apart from the viewer so the report can ask without loading three.js.
 */
let cached = null;

export function canRender3D() {
  if (cached !== null) return cached;
  try {
    const gl = typeof window !== 'undefined' && window.WebGL2RenderingContext
      ? document.createElement('canvas').getContext('webgl2')
      : null;
    cached = Boolean(gl);
    gl?.getExtension('WEBGL_lose_context')?.loseContext();
  } catch {
    cached = false;
  }
  return cached;
}
